import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IAttendee from "../../dataProvider/interfaces/IAttendee";
import AttendeeTimeline from './AttendeeTimeline';

export interface IProps {
  attendee: IAttendee;
  timezone: string;
  open: boolean;
  handleClose: () => void;
}

const AttendeeTimelinePopup = ({ attendee, timezone, open, handleClose }: IProps) => {
  const firstName = attendee.fieldValues.fname || attendee.firstName || "";
  const lastName = attendee.fieldValues.lname || attendee.lastName || "";
  const name = [firstName, lastName].join(" ").trim();
  const title = name ? `Timeline of ${name}` : "Timeline"

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        // fullWidth
        scroll='paper'
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        maxWidth='md'
      >
        <DialogTitle id="scroll-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <AttendeeTimeline attendee={attendee} timezone={timezone} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AttendeeTimelinePopup;
